import { useSuspenseQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { useExecutorRoleViewAuthorizationServiceContext } from '../../../context/contexts';
import { Dashboards, PageConfig } from '../dashboards/types';
import { ExportModalContext } from './contexts';
import { ExportOptions } from './types';

export const useShowExportOptions = (pageConfig: PageConfig) => {
  const authorizationService = useExecutorRoleViewAuthorizationServiceContext();
  const { data: canExportChartView } = useSuspenseQuery({
    queryKey: [
      'show-export-options',
      pageConfig.dashboardId,
      ...authorizationService.getDeps(),
    ],
    queryFn: () => {
      return authorizationService.canExportChartView(
        pageConfig.dashboardId as Dashboards
      );
    },
  });
  const showExportOptions = {
    [ExportOptions.PDF_IMAGE]: canExportChartView,
    [ExportOptions.PNG_IMAGE]: canExportChartView,
  };
  return showExportOptions;
};

export const useExportModal = () => {
  const context = useContext(ExportModalContext);
  if (!context) {
    throw new Error('useExportModal must be used within a ExportModalProvider');
  }
  return context;
};
